<template>
    <v-dialog v-model="shown" :overlay-opacity="0.8" width="85%" overlay-color="black">
        <v-card class="d-flex flex-column " v-if="shown" style="height: 90vh">
            <div class="d-flex align-center">
                <div class="dlg-title-bar flex-grow-1">
                    {{format(new Date(snapshot.runKey + '-01'), 'MMMM')}}
                    <div class="caption">
                        {{format(new Date(snapshot.runTime), dateFormats.longDate)}}
                    </div>
                </div>

                <div class="py-2">
                    <v-text-field
                            v-model="searchStr"
                            clearable
                            outlined
                            dense
                            hide-details
                            prepend-inner-icon="mdi-magnify"
                            placeholder="Search"
                    ></v-text-field>
                </div>

                <div class="px-2">
                    <v-btn
                            icon
                            color="error"
                            @click="shown = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>
            </div>
            <div class="flex-grow-1 of-y fill-height" ref="scrollDiv">
                <v-data-table
                        :headers="headers"
                        :items="snapshot.snapshot"
                        :items-per-page="snapshot.snapshot.length"
                        class="full-table fill-height"
                        hide-default-footer
                        fixed-header
                        item-key="_id"
                        :search="searchStr"
                        single-expand
                        show-expand
                >

                    <template v-slot:item.devices="{ item }">{{item.devices.length}}</template>

                    <template v-slot:item.disabled="{ item }">
                        <div class="overline d-flex align-center" :class="item.disabled ? 'amber--text' : null">
                            {{item.disabled}}
                        </div>
                    </template>

                    <template v-slot:expanded-item="{ headers, item }">

                        <td :colspan="headers.length" style="height: auto" class="grey darken-4">
                            <v-card class="my-4">
                                <v-data-table
                                        :headers="deviceHeaders"
                                        :items="item.devices"
                                        :items-per-page="item.devices.length"
                                        class="full-table"
                                        hide-default-footer
                                        item-key="_id"
                                        fixed-header
                                />
                            </v-card>

                        </td>

                    </template>

                </v-data-table>

<!--                <div class="d-flex flex-column justify-center" v-for="day in screensByDateTime.values()" :key="day.dy">-->
<!--                    <div class="d-flex align-center">-->
<!--                        <div class="circle-small-outline">-->
<!--                            <v-icon color="primary">mdi-calendar</v-icon>-->
<!--                        </div>-->
<!--                        <div class="date-title">-->
<!--                            {{ format(day.date, dateFormats.longDateOnly) }}-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    <div class="line"></div>-->

<!--                    <div class="d-flex align-stretch" v-for="hour in day.hourMap.values()">-->

<!--                        <div class="d-flex flex-column">-->
<!--                            <div class="d-flex align-center">-->
<!--                                <div class="time-title">-->
<!--                                    {{ format(hour.date, dateFormats.hourOnly) }}-->
<!--                                </div>-->
<!--                                <div class="circle-small"></div>-->
<!--                            </div>-->
<!--                            <div class="line flex-grow-1"></div>-->
<!--                        </div>-->

<!--                        <div class="pa-2 pl-10 d-flex align-stretch flex-wrap">-->
<!--                            <div v-for="shot in hour.shots" class="flex-grow-1 pb-8 pr-8" style="max-width: 350px" :key="shot._id">-->
<!--                                <app-screenshot-card-->
<!--                                        :screenshot="shot"-->
<!--                                        @showScreenshot="$emit('showScreenshot', shot)"-->
<!--                                        @gotoDeviceSettings="$emit('gotoDeviceSettings', $event)"-->
<!--                                        @gotoEmployee="$emit('gotoEmployee', $event)"-->
<!--                                        @gotoTeam="$emit('gotoTeam', $event)"-->
<!--                                />-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->

<!--                <div>-->
<!--                    <div class="d-flex flex-column">-->
<!--                        <div class="d-flex align-center">-->
<!--                            <div class="time-title">-->
<!--                                <template v-if="drawLimit < filteredScreenShots.length">-->
<!--                                    +{{filteredScreenShots.length - drawLimit}}-->
<!--                                </template>-->
<!--                            </div>-->
<!--                            <div class="circle-small"></div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->

<!--                <div class="d-flex justify-center pa-5" v-if="drawLimit < filteredScreenShots.length">-->
<!--                    <v-btn-->
<!--                            outlined-->
<!--                            color="primary"-->
<!--                            @click="drawLimit = drawLimit + 50 >= filteredScreenShots.length ? filteredScreenShots.length : drawLimit + 50"-->
<!--                            :loading="true"-->
<!--                    >-->
<!--                        <v-icon left>mdi-plus</v-icon>-->
<!--                        Load More-->
<!--                    </v-btn>-->
<!--                </div>-->
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import {format} from "date-fns";
import {dateFormats} from "@/core/codeFunctions";

export default {
    data() {
        return {
            shown: false,
            snapshot: null,
            searchStr: null,
            format,
            dateFormats,
            headers: [
                {text: 'Employee', value: 'name'},
                {text: 'Disabled', value: 'disabled'},
                {text: 'No. of Devices', value: 'devices'},
                {text: 'No. of Days Tracked (All Devices)', value: 'daysUsed'},
                {text: 'Devices Info', value: 'data-table-expand', width: 150, align: 'end'},
            ],

            deviceHeaders: [
                {text: 'Device Name', value: 'name'},
                {text: 'No. of Days Tracked', value: 'daysUsed'},
            ],
        }
    },
    props: {
        someVal: Boolean,
    },
    methods: {
        previewSnapshot(snapshot) {
            this.shown = true;
            this.snapshot = snapshot
            this.searchStr = null
        }
    },
}
</script>

<style scoped>

</style>